import { render, staticRenderFns } from "./TermFeeRequestYearBatch.vue?vue&type=template&id=1455f134"
import script from "./TermFeeRequestYearBatch.vue?vue&type=script&lang=js"
export * from "./TermFeeRequestYearBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports